import {
  Bell,
  BarChart3,
  FileText,
  Building2,
  Anchor,
  Globe,
  FlaskConical,
} from 'lucide-react';

/** Policy Maker workspace routes (geo supply-chain screens). */
export const POLICY_MAKER_WORKSPACE_ROUTES = [
  {
    id: 'alerts',
    route: 'alerts',
    path: '/policy-makers/alerts',
    label: 'Alerts',
    shortLabel: 'Alerts',
    icon: Bell,
  },
  {
    id: 'import-exposure',
    route: 'import-exposure',
    path: '/policy-makers/import-exposure',
    label: 'Import exposure',
    shortLabel: 'Import',
    icon: BarChart3,
  },
  {
    id: 'trade-agreements',
    route: 'trade-agreements',
    path: '/policy-makers/trade-agreements',
    label: 'Trade agreements',
    shortLabel: 'Trade',
    icon: FileText,
  },
  {
    id: 'domestic-capability',
    route: 'domestic-capability',
    path: '/policy-makers/domestic-capability',
    label: 'Domestic capability',
    shortLabel: 'Domestic',
    icon: Building2,
  },
  {
    id: 'ports-logistics',
    route: 'ports-logistics',
    path: '/policy-makers/ports-logistics',
    label: 'Ports and logistics',
    shortLabel: 'Ports',
    icon: Anchor,
  },
  {
    id: 'geopolitical-risk',
    route: 'geopolitical-risk',
    path: '/policy-makers/geopolitical-risk',
    label: 'Geopolitical risk',
    shortLabel: 'Geo risk',
    icon: Globe,
  },
  {
    id: 'scenarios',
    route: 'scenarios',
    path: '/policy-makers/scenarios',
    label: 'Scenarios',
    shortLabel: 'Scenarios',
    icon: FlaskConical,
  },
];

/** Legacy route slugs → current routes (bookmarks and old feature flags). */
export const POLICY_MAKER_LEGACY_ROUTE_REDIRECTS = {
  'import-bill': 'import-exposure',
  'china-exposure': 'domestic-capability',
  'mou-tracker': 'trade-agreements',
  chokepoints: 'ports-logistics',
  'peer-nations': 'geopolitical-risk',
};

/** Legacy feature ids (policy_maker:import-bill) → current ids. */
export const POLICY_MAKER_LEGACY_FEATURE_IDS = {
  'import-bill': 'import-exposure',
  'china-exposure': 'domestic-capability',
  'mou-tracker': 'trade-agreements',
  chokepoints: 'ports-logistics',
  'peer-nations': 'geopolitical-risk',
};

export const POLICY_MAKER_PAGE_FEATURES = POLICY_MAKER_WORKSPACE_ROUTES.map(
  (t) => `policy_maker:${t.id}`,
);

export function policyMakerPageFeature(routeId) {
  return `policy_maker:${routeId}`;
}

export function resolvePolicyMakerRouteId(routeOrFeatureId) {
  const id = routeOrFeatureId?.startsWith('policy_maker:')
    ? routeOrFeatureId.slice('policy_maker:'.length)
    : routeOrFeatureId;
  return POLICY_MAKER_LEGACY_FEATURE_IDS[id] || id;
}

export function policyMakerSlugFromPathname(pathname) {
  const base = '/policy-makers/';
  if (!pathname.startsWith(base)) return null;
  const slug = pathname.slice(base.length).split('/')[0];
  if (!slug) return 'alerts';
  return POLICY_MAKER_LEGACY_ROUTE_REDIRECTS[slug] || slug;
}

export function policyMakerRouteBySlug(slug) {
  const resolved = POLICY_MAKER_LEGACY_ROUTE_REDIRECTS[slug] || slug;
  return (
    POLICY_MAKER_WORKSPACE_ROUTES.find((r) => r.route === resolved)
    || POLICY_MAKER_WORKSPACE_ROUTES[0]
  );
}
